import "core-js/modules/es6.regexp.split";
import Quasar from 'quasar/src/vue-plugin.js';;
export var setQuasarInternalLanguage = function setQuasarInternalLanguage(qLang) {
  if (qLang !== 'en-us') qLang = qLang.split('-')[0];
  import(
  /* webpackInclude: /(ru|en-us)\.js$/ */
  "quasar/lang/".concat(qLang)).then(function (lang) {
    Quasar.lang.set(lang.default);
  });
};